module.exports = __webpack_public_path__ + "img/dual-temperature-sm.c5f78abb.svg";